export const CHANGED_CHUNK_NAME = 'bulk-attendees-import';
export const UPLOAD_BULK_IMPORT_USER_TEMPLATE = '/static/Bulk-import-attendees-template.csv';

export const MAX_FILE_SIZE = 100_000_000;
export const UPLOAD_FILE_MAX_SIZE_LIMIT_MB = 250;
export const UPLOAD_FILE_VALID_EXTENSIONS = ['.csv'];
export const MAX_RECORD_SIZE = 2000;
export const BROKEN_TEMPLATE_MESSAGE = 'The file does not contain the required columns. Please make sure the file' +
    ' matches the template.';
export const MISSING_HEADER_ROW_MESSAGE = 'File can\'t be parsed. Table doesn\'t have column names.';
export const MISSING_EMAIL_COLUMN_MESSAGE = 'File does not contain Email column. Please make sure the file matches' +
    ' the template';
export const INVALID_FILE_TYPE_MESSAGE = 'Invalid file type. Please upload a CSV file.';

export const FIELD: {
    EMAIL: string,
    FIRST_NAME: string,
    LAST_NAME: string,
    COUNTRY: string,
    CONFERENCE_ACCOUNT: string,
    PRIMARY_ACCOUNT: string,
    JOB_TITLE: string,
    CITY: string,
    NOTES: string,
} = {
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    COUNTRY: 'country',
    CONFERENCE_ACCOUNT: 'conferenceAccount',
    PRIMARY_ACCOUNT: 'primaryAccount',
    JOB_TITLE: 'jobTitle',
    CITY: 'city',
    NOTES: 'notes',
};

export const HEADERS = {
    [FIELD.EMAIL]: 'Email',
    [FIELD.FIRST_NAME]: 'First Name',
    [FIELD.LAST_NAME]: 'Last Name',
    [FIELD.CONFERENCE_ACCOUNT]: 'Conference Account*',
    [FIELD.PRIMARY_ACCOUNT]: 'Primary Account',
    [FIELD.COUNTRY]: 'Country',
    [FIELD.JOB_TITLE]: 'Job Title',
    [FIELD.CITY]: 'City',
    [FIELD.NOTES]: 'Notes',
};

export const MATCHING_LIST = [
    {caption: HEADERS[FIELD.EMAIL], required: true},
    {caption: HEADERS[FIELD.FIRST_NAME], required: true},
    {caption: HEADERS[FIELD.LAST_NAME], required: true},
    {caption: HEADERS[FIELD.JOB_TITLE]},
    {caption: HEADERS[FIELD.COUNTRY]},
    {caption: HEADERS[FIELD.CITY]},
    {caption: HEADERS[FIELD.NOTES]},
];
